// IMAGE SLOTS (Vechtsport Kids Ready, Dutch copy of Martial Arts Kids Class Ready)
// Hosted in the Impultienda store resources (Recursos) of the Dutch store.
const STORE = '9439f08f-8d77-41be-8090-e248deb9ca37';
const RES = `https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/${STORE}/`;

/**
 * iMac + 3 tablets + 2 phones, one bonus per device. Composited in code (no AI text): the Dutch Gamma Studio cover plus
 * real pages on the iMac, and the Impultienda bonus photos with their Dutch titles typed in. Pure white background.
 */
const IMAC = RES + '1792939460779_nl-mockup-imac-790440e5.webp';
export const heroMockupUrl = IMAC;
export const offerMockupUrl = IMAC;
/**
 * Real pages of the Dutch Gamma Studio book (9:16), same order as lookInside.captions: p.6, 20, 12, 13, 37, 39.
 * Only pages that passed the page-by-page check of the Dutch book (25/10); never p.4, 5, 21, 36, 38 or 40.
 */
export const pageImages: string[] = [
  RES + '1792941839503_nl-pagina-06-plan-q3-07c537c6.webp',
  RES + '1792941843901_nl-pagina-20-les05-lesplan-3bb0a088.webp',
  RES + '1792941848455_nl-pagina-12-les02-uitleg-2154ac80.webp',
  RES + '1792941853017_nl-pagina-13-les02-oefeningen-3f7bd5d1.webp',
  RES + '1792941856984_nl-pagina-37-les10-bandexamen-391b37d6.webp',
  RES + '1792940551495_nl-pagina-39-lesplanner-51981080.webp',
];
/** 5 bonus covers (Dutch titles typed in code), in the same order as bonuses (and as the checkout) */
export const bonusCovers: string[] = [
  RES + '1792939465096_nl-bono-juegos-d9c0ad64.webp',
  RES + '1792939469306_nl-bono-cinturon-9991a31d.webp',
  RES + '1792939473199_nl-bono-padres-88a38d8d.webp',
  RES + '1792939477105_nl-bono-pads-b6dfadac.webp',
  RES + '1792939481268_nl-bono-prueba-706cc425.webp',
];
